import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import { PlaceAdapter } from '@core/models/place.model';
import { MediaFile } from '@core/models/media-file.model';
import { SessionListItemAdapter } from '@core/models/course/session-list-item.model';

@Injectable({
  providedIn: 'root'
})
export class MediaAdapter implements Adapter<MediaFile> {
  constructor(private placeAdapter: PlaceAdapter) {
  }

  adapt(item: any): MediaFile {
    const sessionListAdapter = new SessionListItemAdapter()
    return new MediaFile(
      item.id,
      item.media?.name ?? item.media?.fileObject.originalFileName,
      item.media?.fileObject.fileUrl,
      item.availableFrom ?? item.createdAt,
      'file',
      (typeof(item.session) != 'string' && item.session) ? sessionListAdapter.adapt(item.session) : undefined,
      item.branch,
      item.series
    );
  }

  adaptFromCustom(item: any): MediaFile {
    const sessionListAdapter = new SessionListItemAdapter()
    return new MediaFile(
      item.id,
      item.fileName,
      item.path,
      (item.availableFrom ?? item.createdAt) ?? new Date(),
      'file',
      item.session ? sessionListAdapter.adapt(item.session) : undefined,
      item.branch,
      item.series
    );
  }

  adaptFromArticle(item:any):MediaFile{
    return new MediaFile(
      item.id,
      item.fileObject.originalFileName,
      item.fileObject.fileUrl,
      new Date()
    )
  }
  adaptFromUpload(item:any):MediaFile{
    return new MediaFile(
      item.id,
      item.originalFileName,
      item.fileUrl,
      new Date(),
      'file',
      undefined,
      undefined,
      undefined,
      item.type
    )
  }


  
}
